// Neutral Default scorecard for initial display (matches CALL-TYPE-TEMPLATES.md "Default /
// Fallback"). Shown before import so the expected-minimum panel is never empty. Not IP — just
// neutral expected minimums; the server re-validates whatever is submitted on RUN.
import type { ManagerScorecard } from './types.js';

const S = (skill_id: string, skill_name: string, expected: number, importance: 'Standard' | 'Important' | 'Critical') => ({
  skill_id,
  skill_name,
  expected_score: expected,
  importance,
  weight: importance === 'Critical' ? 2.0 : importance === 'Important' ? 1.5 : 1.0,
  critical: false,
});

export const DEFAULT_SCORECARD: ManagerScorecard = {
  contract_version: '1.1',
  template_id: 'tmpl-default',
  template_name: 'Default / Fallback (call type not identified)',
  owner_user_id: 'system-default',
  call_type_hint: null,
  skills: [
    S('upfront-contract', 'Setting Expec.', 3, 'Standard'),
    S('call-prep', 'Call Prep', 3, 'Standard'),
    S('personalization', 'Personalization', 3, 'Important'),
    S('problem-development', 'Problem Dev', 3, 'Important'),
    S('moneyball-gap-score', 'Moneyball Gap Identifier', 3, 'Standard'),
    S('aha-moment', 'A-Ha Moment', 3, 'Standard'),
    S('objection-handling', 'Objection Handling', 0, 'Standard'), // optional by default (matches systemTemplates GRID)
    S('competitive-proactivity', 'Competitive', 3, 'Standard'),
    S('domain-expertise', 'Domain Expertise', 3, 'Standard'),
    S('active-listening', 'Active Listening', 3, 'Important'),
    S('next-steps', 'Next Steps', 3, 'Standard'),
  ],
};

// Blank scorecard for the idle / just-cleared state (no transcript, no call type). Shows the skill
// rows but with NO minimums set and neutral weights — a true "from scratch" slate — rather than
// imposing the Default/Fallback values before any call type is identified. The Default/Fallback
// scorecard is still applied by the worker as the SCORING fallback when an imported call's type
// can't be identified.
export const BLANK_SCORECARD: ManagerScorecard = {
  ...DEFAULT_SCORECARD,
  template_id: 'tmpl-blank',
  template_name: '',
  skills: DEFAULT_SCORECARD.skills.map((s) => ({ ...s, expected_score: 0, importance: 'Standard' as const, weight: 1.0, critical: false })),
};
